







import { Component, Vue } from 'vue-property-decorator';
import publishedEforms from '@/components/eforms/publishedEforms.vue';


@Component({
  components: {
    publishedEforms,
  },
})
export default class eformsPublished extends Vue {}
